import { DropdownMenu } from 'components/ui'
import { ChevronDown } from 'lucide-react'
import React from 'react'
import { Text, Flex } from '@chakra-ui/core'
import { FrequencyType } from 'components/NewsFeed/PollTaskForm/utils'
import useLocaleText from 'components/useLocaleText'
import { Controller, useFormContext } from 'react-hook-form'
import { useFormStepContext } from '../../FormStepContext'
import { getMaxAllowedDays } from './utils'

export const FrequencyMenu = () => {
  const { control, setValue, watch } = useFormContext()
  const { isEdit, setMaxAllowedOverdueDays } = useFormStepContext()

  const recurrenceFrequency = watch('recurrence_frequency')
  const isRecurring = watch('is_recurring')

  const t_day = useLocaleText('t_day')
  const t_week = useLocaleText('t_week')
  const t_month = useLocaleText('t_month')
  const t_recurring = useLocaleText('t_recurring')

  const handleSelect = (value: FrequencyType) => {
    setValue('recurrence_frequency', value)
    setValue('days_of_week', null)
    setValue('allowed_overdue_days', '')

    const maxDays = getMaxAllowedDays(value)

    setMaxAllowedOverdueDays(maxDays)
  }

  return (
    <Flex
      display={isRecurring ? 'flex' : 'none'}
      alignItems="center"
      style={{ columnGap: '10px' }}
      pointerEvents={isEdit ? 'none' : 'auto'}
      opacity={isEdit ? 0.5 : 1}
    >
      <Text>{t_recurring}</Text>
      <Controller
        name="recurrence_frequency"
        control={control}
        as={
          <DropdownMenu
            usePortal
            isDisabled={isEdit || !isRecurring}
            options={[
              { id: String(FrequencyType.DAY), value: FrequencyType.DAY, label: <>{t_day}</> },
              { id: String(FrequencyType.WEEK), value: FrequencyType.WEEK, label: <>{t_week}</> },
              { id: String(FrequencyType.MONTH), value: FrequencyType.MONTH, label: <>{t_month}</> },
            ]}
            selectedId={String(recurrenceFrequency)}
            onSelect={({ value }) => handleSelect(value)}
            triggerVariant="secondary"
            triggerButtonProps={{
              type: 'button',
              height: '36px',
              minWidth: '100px',
              px: '12px',
              justifyContent: 'space-between',
            }}
            triggerContent={
              <>
                {recurrenceFrequency === FrequencyType.MONTH
                  ? t_month
                  : recurrenceFrequency === FrequencyType.WEEK
                  ? t_week
                  : t_day}
                <ChevronDown size={14} />
              </>
            }
          />
        }
      />
    </Flex>
  )
}
